<template>
    <v-app>
        <div class="card card-custom card-stretch gutter-b">

            <!-- Popups -->
            <qrcode-popup />
            <verify-report-popup />

            <!--begin::Header-->
            <div class="card-header border-0 py-5">
                <h3 class="card-title align-items-start flex-column">
                    <span class="card-label font-weight-bolder text-dark" v-if="utils.is_report_empty">
                        Reports ({{0}})
                    </span>
                    <span class="card-label font-weight-bolder text-dark" v-else>
                        Reports ({{reports.length}})
                    </span>
                    <span class="text-muted mt-3 font-weight-bold font-size-sm">
                        All created reports will appear here
                    </span>
                </h3>
                <div class="card-toolbar">
                    <div @click="showVerifyReport()" class="btn btn-success font-weight-bolder font-size-sm">
                        <span class="svg-icon svg-icon-md svg-icon-white">
                        </span> Verify <i class=" mdi mdi-database-search pl-3" style=" font-size:20px;"></i>
                    </div>
                </div>
            </div>
            <!--end::Header-->

            <!--Body for reports available-->
            <div class="card-body py-0 pb-10" v-if="!utils.is_report_empty">
                <!--begin::Table-->
                <div class="table-responsive">
                    <table class="table table-head-custom table-vertical-center">
                        <thead>
                        <tr class="text-left">
                            <th class="pr-0" style="width: 100px"></th>
                            <th @click="sortReports()" class="pr-0" style="width: 250px">Date
                                <span class="position-relative">
                                        <i :class="{sort_menu_active: utils.active_sort_icon === 'sort_icon_1' }"
                                           @click="utils.active_sort_icon = 'sort_icon_1'"
                                           class="mdi mdi-menu-up sort-menu-up"></i>
                                        <i :class="{sort_menu_active: utils.active_sort_icon === 'sort_icon_2' }"
                                           @click="utils.active_sort_icon = 'sort_icon_2'"
                                           class="mdi mdi-menu-down sort-menu-down"></i>
                                    </span>
                            </th>
                           <th style="min-width: 100px">Type</th>
                            <th style="min-width: 50px"></th>
                            <th style="min-width: 100px">Source</th>
                            <th style="min-width: 150px">Report Hash</th>
                            <th class="pr-0 text-right" style="min-width: 150px"></th>
                        </tr>
                        </thead>

                        <tbody>
                           <template v-for="(el, i) in reports">
                            <tr :key="i">
                                <td class="pr-0">
                                    <div class="symbol symbol-50 mt-1">
                                        <span class="snapshot-thumbnail">
                                            <img v-if="el.type.toLowerCase() === 'screenproof'" :src="el.captured_file" alt="avatar" class="h-75">
                                           <img v-else-if="el.type.toLowerCase() === 'picscan'" :src="el.captured_file" alt="avatar" class="h-75">
                                            <i v-else class="mdi mdi-file-pdf-outline" style="font-size: 30px; color: #82037e"></i>
                                        </span>
                                    </div>
                                </td>
                                <td class="pl-0">
                                    <span class="text-dark-75 font-weight-bold">
                                        {{ el.created_at | dateMills }} <span class="pl-3"> {{ el.created_at | timeMills }} </span>
                                    </span>
                                </td>
                               <td class="pl-0">
                                    <span class="text-dark-75 font-weight-bold">
                                        {{ el.type }}
                                    </span>
                               </td>
                                <td>
                                    <a :href="el.source" class="custom-href font-weight-bold d-block" target="_blank">
                                        {{ el.source | limit(10) }} <i class=" mdi mdi-open-in-new pl-1" style="font-size: 13px;position: relative;top: 3px;color: inherit;"></i>
                                    </a>
                                </td>
                                <td>
                                    <a :href="'https://ropsten.etherscan.io/tx/' + el.transaction_hash"
                                       class="custom-href font-weight-bold d-block" target="_blank">
                                        {{ el.transaction_hash | limit(20) }}
                                        <i class="mdi mdi-open-in-new pl-1" style="font-size: 13px;position: relative;top: 3px;color: inherit;"></i>
                                    </a>
                                    <button @click="showQrcodePopup(el)" class="mt-1 btn-verify-hash btn-hover-primary btn-sm">
                                        <i class="mdi mdi-qrcode pr-1"
                                           style="font-size: 13px;position: relative;top: 3px;color: inherit;"></i>
                                        Scan QR code
                                    </button>
                                </td>
                                <td class="pr-0 text-right">
                                    <a :class="{disabled: utils.deleting_report || el.all_signatures === 'INCOMPLETE'}"
                                       @click="deleteTheRightPdf(el)"
                                       class="btn btn-icon btn-semi-light btn-hover-primary btn-sm mx-5">
                                       <template v-if="swap.deleting_id === el.id && utils.deleting_report">
                                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                       </template>
                                       <template v-else>
                                           <i class=" mdi mdi-delete-outline"
                                              style="font-size: 20px;position: relative;top: 1px;color: inherit;">
                                           </i>
                                       </template>
                                    </a>
                                    <a :class="{'disabled': utils.is_pdf_downloading || el.all_signatures === 'INCOMPLETE'}"
                                       class="btn btn-icon btn-semi-light btn-hover-primary btn-sm"
                                       @click="downloadTheRightPdf(el)">
                                        <template v-if="swap.downloading_id === el.id && utils.is_pdf_downloading">
                                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                        </template>
                                        <template v-else>
                                            <i class="mdi mdi-download" style="font-size: 20px;position: relative;top: 1px;color: inherit;"></i>
                                        </template>
                                    </a>
                                    <a @click="showVerifyReport(el)"
                                       class="mt-1 btn-verify-hash-outline btn-hover-primary btn-sm mx-5" href="#">
                                        Verify
                                    </a>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
                <!--end::Table-->
            </div>
            <!--Body for reports available-->

            <!--Body for no reports-->
            <div class="card-body py-0 pb-10 m-auto" v-else>
                <div class="row col-centered text-center">
                    <div class="col-sm-12 col-md-7 col-lg-10 col-centered">
                        <img alt="icon" class="pt-9" src="/media/misc/no-reports.png" width="80"/>
                        <div class="custom-title pt-7">
                            You have not created any report on this account
                        </div>
                    </div>
                </div>
                <div class="text-center pt-10">
                    <a @click="goToCreateReport()" class="btn btn-success font-weight-bold report-created-btn" href="#">
                        Create Your First Report Now
                    </a>
                </div>
            </div>
            <!--Body for no reports-->

        </div>
    </v-app>
</template>

<script>

   import {bus} from '../../main';
   import {mapGetters} from 'vuex';
   import QrcodePopup from '../content/custom/QrcodePopup';
   import generalMixin from '../../core/mixins/generalMixin';
   import {FETCH_REPORT} from '../../core/store/modules/report';
   import {SET_BREADCRUMB} from "@/core/store/modules/breadcrumbs";
   import VerifyReportPopup from '../content/custom/VerifyReportPopup';

   export default {
      name: "MyReports",
      data() {
         return {
            utils: {
               is_report_empty: true,
               deleting_report: false,
               active_sort_icon: '',
               is_pdf_downloading: false,
            },
            swap: {
               deleting_id: '',
               downloading_id: '',
            }
         }
      },
      components: {
         QrcodePopup,
         VerifyReportPopup
      },
      mixins: [generalMixin],
      methods: {
         sortReports() {
            this.reports.reverse();
         },
         showQrcodePopup(el) {
            bus.$emit('open_qrcode_popup', {img_hash: el.captured_file_hash});
         },
         showVerifyReport(el) {
            bus.$emit('open_report_popup', el);
         },
         goToCreateReport() {
            this.$router.push({name: 'create_report'});
         },
         deleteReport(report) {
            this.startDeletingProcess(report.id);
            setTimeout(() => {
               let action = this.getDeleteAction(report.type);
               this.$store.dispatch(action, report).then((res) => {
                  console.log(res);
                  this.stopDeletingProcess(report.id);
               }).catch((err) => {
                  console.log(err);
                  this.stopDeletingProcess(report.id);
               });
            }, 1000);
         },
         downloadPdf(report) {
            this.startDownloadingProcess(report.id);
            let action = this.getDownloadAction(report.type);
            this.$store.dispatch(action, report.id).then((res) => {
               this.stopDownloadingProcess(res);
            }).catch((err) => {
               this.stopDownloadingProcess(err);
               alert('download encountered error, please try again');
            });
         },
         deleteTheRightPdf(report) {
            if(report.type === 'SIGNPROOF') {
               if(report.all_signatures !== undefined) {
                  if(report.all_signatures === 'COMPLETE') {
                     this.deleteReport(report);
                  } else {
                     console.log('signatures is not complete for delete');
                  }
               } else {
                  this.deleteReport(report);
               }
            } else {
               this.deleteReport(report);
            }
         },
         downloadTheRightPdf(report) {
            if(report.type === 'SIGNPROOF') {
               if(report.all_signatures !== undefined) {
                  if(report.all_signatures === 'COMPLETE') {
                     this.downloadPdf(report);
                  } else {
                     console.log('signatures is not complete for download');
                  }
               } else {
                  this.downloadPdf(report);
               }
            } else {
               this.downloadPdf(report);
            }
         },
         startDeletingProcess(id) {
            this.swap.deleting_id = id;
            this.utils.deleting_report = true;
         },
         stopDeletingProcess(id) {
            console.log(id);
            this.swap.deleting_id = id;
            this.utils.deleting_report = false;
         },
         startDownloadingProcess(id) {
            this.swap.downloading_id = id;
            this.utils.is_pdf_downloading = true;
         },
         stopDownloadingProcess(r) {
            console.log(r);
            this.swap.downloading_id = '';
            this.utils.is_pdf_downloading = false;
         }
      },
      computed: {
         ...mapGetters([
            'reports'
         ])
      },
      mounted() {
         this.$store.dispatch(SET_BREADCRUMB, [{
            title: "My Reports"
         }]);
      },
      watch: {
         'reports'(data) {
            if (data) {
               this.utils.is_report_empty = data.length < 1;
            }
         }
      },
      created() {
         this.$store.dispatch(FETCH_REPORT, this.$store.getters.user.uid);
      }
   };
</script>


<style scoped>
    .v-application--wrap {
        min-height: inherit !important;
    }

    .theme--light.v-application {
        background: inherit !important;
        color: inherit !important;
    }

    .v-application {
        font-family: inherit !important;
        line-height: inherit !important;
        font-weight: inherit !important;
    }

    .v-application .font-weight-bold {
        font-weight: 500 !important;
    }

    .disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }
</style>